import React from "react";
import { Table } from "reactstrap";
import { SimpleRow } from "../../../../../layout/Table/SimpleRow";

function UserDetailsTable(props) {
  const { user } = props;

  if (! user || ! user.id) {
    return <Table className="align-items-center table-flush" responsive striped>
      <tbody>
      <SimpleRow translationKey="messages.no_data" value=""/>
      </tbody>
    </Table>
  }

  return (
    <Table className="align-items-center table-flush" responsive striped>
      <tbody>
      <SimpleRow translationKey="components.pages.users.usersTable.table.id"
                 value={user.id}/>
      <SimpleRow translationKey="fields.firstName" value={user.first_name}/>
      <SimpleRow translationKey="fields.lastName" value={user.last_name}/>
      <SimpleRow translationKey="fields.email" value={user.email}/>
      </tbody>
    </Table>
  );
}

export { UserDetailsTable };
